import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "px-3 py-3",
  style: {"background":"#409EFF"}
}

import { ref } from 'vue';
    import { useStore } from 'vuex';
    import { useRouter } from 'vue-router';
    import { useFullscreen } from '@vueuse/core'
    import { ElButton, ElCol, ElInput, ElRow } from 'element-plus';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'LayoutView',
  setup(__props) {

    const store = useStore();
    const router = useRouter();
    const phone = ref<string>('')
    const password = ref<string>('')


    const isSidebarOpen = ref(false);
    const activeMenu = ref<string>(store.getters.route)

    router.beforeEach(route => {
        activeMenu.value = route.path
    })

    const toggleSidebar = () => {
        isSidebarOpen.value = !isSidebarOpen.value;
    };

    const { isFullscreen, toggle: toggleFullscreen } = useFullscreen();
    
    const logout = async () => {
        sessionStorage.removeItem('password')
        sessionStorage.removeItem('phone')
        router.push("/?key=" + new Date())
    }
    
    const login = () => {
        console.log(9000)
        sessionStorage.setItem('password', password.value)
        sessionStorage.setItem('phone', phone.value)
        location.reload()
    }

return (_ctx: any,_cache: any) => {
  const _component_Rank = _resolveComponent("Rank")!
  const _component_FullScreen = _resolveComponent("FullScreen")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_HomeFilled = _resolveComponent("HomeFilled")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "app-layout" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, {
        class: "app-header p-0",
        height: "1"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElRow), {
            justify: "space-between",
            align: "middle",
            class: "p-2 col-12"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElCol), { class: "col-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElButton), {
                    icon: "Menu",
                    onClick: toggleSidebar,
                    class: "menu-toggle-button"
                  }),
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "app-title" }, "DashBoard Beasy ", -1))
                ]),
                _: 1
              }),
              _createVNode(_unref(ElRow), {
                align: "middle",
                gutter: 15
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElCol), { class: "d-none d-sm-inline col-auto" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tooltip, {
                        effect: "light",
                        content: "Modo tela cheia",
                        placement: "bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            role: "button",
                            onClick: _unref(toggleFullscreen)
                          }, {
                            default: _withCtx(() => [
                              (_unref(isFullscreen))
                                ? (_openBlock(), _createBlock(_component_Rank, { key: 0 }))
                                : (_openBlock(), _createBlock(_component_FullScreen, { key: 1 }))
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(ElCol), { class: "col-auto" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tooltip, {
                        effect: "light",
                        content: "Terminar sesssao",
                        placement: "bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            shape: "circle",
                            role: "button",
                            onClick: logout
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_SwitchButton)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(login, ["prevent"]),
          class: "v-col-12"
        }, [
          _createVNode(_unref(ElRow), { class: "v-col-12" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElCol), {
                cols: 25,
                class: "px-2"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("h4", null, "Inserir credenciais de entrada", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_unref(ElCol), {
                cols: 24,
                md: 8,
                lg: 6
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElInput), {
                    type: "text",
                    name: "phone",
                    modelValue: phone.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phone).value = $event)),
                    class: "px-2"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(ElCol), {
                cols: 24,
                md: 8,
                lg: 6
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElInput), {
                    type: "password",
                    name: "password",
                    modelValue: password.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                    placeholder: "Insira a senha",
                    class: "px-2"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(ElCol), {
                cols: 24,
                md: 8,
                lg: 6,
                class: "px-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElButton), { "native-type": "submit" }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("Entrar", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 32)
      ]),
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_aside, { class: "app-sidebar col-auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu, {
                collapse: !isSidebarOpen.value,
                "default-active": activeMenu.value,
                "active-text-color": "#ffd04b",
                "background-color": "#545c64",
                class: "el-menu-vertical-demo",
                router: "",
                "unique-opened": "",
                "text-color": "#fff"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, {
                    index: "/companies-dashboard",
                    title: "Perfil"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_HomeFilled)
                        ]),
                        _: 1
                      }),
                      _cache[5] || (_cache[5] = _createElementVNode("span", null, "Informacoes", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["collapse", "default-active"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_main, { class: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})